module.exports = __webpack_public_path__ + "static/img/chuzigongxiang.3aaf1ed4.jpg";